import type { SiteTechStack } from '@/types/auth';

/**
 * The canonical HeyMotek tracking snippet (served at api.heymotek.com/snippet.js).
 * Single source for the onboarding install step, the Website page, and SnippetBlock.
 *
 * Astro needs `is:inline` so its compiler emits the tag verbatim instead of trying
 * to bundle it; the attribute is harmless on every other stack.
 */
export function buildSnippet(clientId: string, stack: SiteTechStack | null): string {
  const extraAttr = stack === 'astro' ? ' is:inline' : '';
  return `<script async src="https://api.heymotek.com/snippet.js" data-client-id="${clientId}"${extraAttr}></script>`;
}
